import React from 'react';
import RecommendationTile from './RecommendationTile';
import { DropdownData } from '@components/ui/Dropdown';
import { Button } from '@components/ui/Button';
import { ArrowLeftIcon } from '@components/ui/Icons';
import { RecommendationDto } from '@cloudclevr/components';

export interface RecommendationsListProps {
  recommendations: RecommendationDto[];
  onViewNotes?: (id: string) => void;
  onDownloadAttachments?: (id: string) => void;
  onViewQuote?: (id: string) => void;
  onDropdownAction?: (action: string, recommendationId: string) => void;
  dropdownActions?: DropdownData[];
  className?: string;
  onEditRecommendation?: (recommendationId: string) => void;
  onBackToRoadmap?: () => void;
  currentTab?: string;
  onDownloadSuccess?: (fileName: string) => void;
  onDownloadError?: (fileName: string) => void;
  roadmapId?: string;
}

const RecommendationsList: React.FC<RecommendationsListProps> = ({
  recommendations,
  onViewNotes,
  onDownloadAttachments,
  onViewQuote,
  onDropdownAction,
  dropdownActions = [],
  onEditRecommendation,
  onBackToRoadmap,
  currentTab,
  className = '',
  onDownloadSuccess,
  onDownloadError,
  roadmapId
}) => {
  if (recommendations.length === 0) {
    return (
      <div className={`py-12 text-center ${className}`}>
        <div className="text-gray-500 text-lg">
          No recommendations found for this category.
        </div>
      </div>
    );
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {recommendations.map((recommendation) => (
        <RecommendationTile
          key={recommendation.id}
          recommendation={recommendation}
          roadmapId={roadmapId}
          onViewNotes={onViewNotes}
          onDownloadAttachments={onDownloadAttachments}
          onViewQuote={onViewQuote}
          onDropdownAction={onDropdownAction}
          dropdownActions={dropdownActions}
          onEditRecommendation={onEditRecommendation}
          currentTab={currentTab}
          onDownloadSuccess={onDownloadSuccess}
          onDownloadError={onDownloadError}
        />
      ))}
       
      <div className="flex justify-left mt-6">
        <Button
          onClick={onBackToRoadmap}
          className="w-[225px] !bg-gray-800 text-white !hover:bg-gray-700 !text-16 !leading-6 md:w-[200px] md:justify-left"
        >
          <ArrowLeftIcon classNames="w-4 h-4 mr-2" color='text-primaryBrandColor-100' />
          Back to roadmap
        </Button>
      </div>
    </div>
  );
};

export default RecommendationsList;